const s3URL = 'https://public.cypherd.io/assets/static-cypherhq';

const Activate_CARD_BANNER = `${s3URL}/activateCardBanner.png`;
const Activate_CARD_STEP1 = `${s3URL}/activateCardStep1.png`;
const Activate_CARD_STEP2 = `${s3URL}/activateCardStep2.png`;
const Activate_CARD_STEP3 = `${s3URL}/activateCardStep3.png`;
const Activate_CARD_STEP4 = `${s3URL}/activateCardStep4.png`;
const Activate_CARD_STEP5 = `${s3URL}/activateCardStep5.png`;
const Activate_CARD_STEP6 = `${s3URL}/activateCardStep6.png`;
const Activate_CARD_STEP7 = `${s3URL}/activateCardStep7.png`;
const MOBILE_Activate_CARD_STEP1 = `${s3URL}/mobileActivateCardStep1.png`;
const MOBILE_Activate_CARD_STEP2 = `${s3URL}/mobileActivateCardStep2.png`;
const MOBILE_Activate_CARD_STEP3 = `${s3URL}/mobileActivateCardStep3.png`;
const MOBILE_Activate_CARD_STEP4 = `${s3URL}/mobileActivateCardStep4.png`;
const MOBILE_Activate_CARD_STEP5_1 = `${s3URL}/mobileActivateCardStep5_1.png`;
const MOBILE_Activate_CARD_STEP5_2 = `${s3URL}/mobileActivateCardStep5_2.png`;
const MOBILE_Activate_CARD_STEP6 = `${s3URL}/mobileActivateCardStep6.png`;
const MOBILE_Activate_CARD_STEP7_1 = `${s3URL}/mobileActivateCardStep7_1.png`;
const MOBILE_Activate_CARD_STEP7_2 = `${s3URL}/mobileActivateCardStep7_2.png`;
const THATS_IT = `${s3URL}/thatsIt.png`;

export const AppImages = {
  Activate_CARD_BANNER,
  Activate_CARD_STEP1,
  Activate_CARD_STEP2,
  Activate_CARD_STEP3,
  Activate_CARD_STEP4,
  Activate_CARD_STEP5,
  Activate_CARD_STEP6,
  Activate_CARD_STEP7,
  MOBILE_Activate_CARD_STEP1,
  MOBILE_Activate_CARD_STEP2,
  MOBILE_Activate_CARD_STEP3,
  MOBILE_Activate_CARD_STEP4,
  MOBILE_Activate_CARD_STEP5_1,
  MOBILE_Activate_CARD_STEP5_2,
  MOBILE_Activate_CARD_STEP6,
  MOBILE_Activate_CARD_STEP7_1,
  MOBILE_Activate_CARD_STEP7_2,
  THATS_IT,
};
